import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
    components: {}
})
export default class Attachment extends Vue {
    @Prop({ type: Array, required: true }) value!: Array<any>;
    @Prop({ type: String, required: false, default: 'note' }) attachmentType!: string;
    @Prop({ type: Boolean, required: false, default: false }) disabled!: boolean;

    fileSelected() {
        let upload = <any>this.$refs.inputUpload;

        for (let i = 0; i <= upload.files.length - 1; i++) {
            this.value.push({ fileName: upload.files[i].name, fileLocation: 'unknown', file: upload.files[i], attachmentType: this.attachmentType });
        }
    }

    removeFile(item: any) {
        //find the item in the attachments array and remove it
        let ind = this.value.findIndex((i: any) => {
            return i.fileName === item.fileName
        });

        if (ind > -1)
            this.value.splice(ind, 1);
    }
}


// WEBPACK FOOTER //
// ./ClientApp/src/components/attachments/attachments.ts